import * as htmlToImage from "html-to-image";

export function DownloadImage(chartContainer, fileName) {
  if (!chartContainer) {
    console.error("Chart container not found");
    return;
  }

  // Try to get the SVG element inside the chart container
  const svgElement = chartContainer.querySelector("svg");
  if (!svgElement) {
    console.error("SVG element not found inside chart container");
    return;
  }

  console.log("Attempting to capture SVG element:", svgElement);

  // Export as PNG from SVG element directly
  htmlToImage
    .toPng(svgElement, { cacheBust: true })
    .then((dataUrl) => {
      const link = document.createElement("a");
      link.download = `${fileName}.png`;
      link.href = dataUrl;
      link.click();
      console.log("PNG image exported successfully");
    })
    .catch((err) => {
      console.error("Failed to generate PNG image", err);

      // Fallback: export as SVG string
      htmlToImage
        .toSvg(svgElement)
        .then((svgUrl) => {
          console.log("SVG export succeeded");
          const link = document.createElement("a");
          link.download = `${fileName}.svg`;
          link.href = svgUrl;
          link.click();
        })
        .catch((svgErr) => console.error("SVG export also failed", svgErr));
    });
}
